"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var reducer_1 = __importDefault(require("./modules/asset_types/reducer"));
var reducer_2 = __importDefault(require("./modules/assets/reducer"));
var reducer_3 = __importDefault(require("./modules/categories/reducer"));
var reducer_4 = __importDefault(require("./modules/feedback/reducer"));
var reducer_5 = __importDefault(require("./modules/layers/reducer"));
var reducer_6 = __importDefault(require("./modules/modals/reducer"));
var reducer_7 = __importDefault(require("./modules/pages/reducer"));
var reducer_8 = __importDefault(require("./modules/releases/reducer"));
var reducer_9 = __importDefault(require("./modules/search/reducer"));
var reducer_10 = __importDefault(require("./modules/sections/reducer"));
var reducer_11 = __importDefault(require("./modules/server/reducer"));
var reducer_12 = __importDefault(require("./modules/settings/reducer"));
var reducer_13 = __importDefault(require("./modules/stations/reducer"));
exports.default = (0, redux_1.combineReducers)({
    assetTypes: reducer_1.default,
    assets: reducer_2.default,
    categories: reducer_3.default,
    feedback: reducer_4.default,
    layers: reducer_5.default,
    modals: reducer_6.default,
    pages: reducer_7.default,
    releases: reducer_8.default,
    search: reducer_9.default,
    sections: reducer_10.default,
    server: reducer_11.default,
    settings: reducer_12.default,
    stations: reducer_13.default,
});
